import React from 'react';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import PrepareOrder from './../../../../prepare-order';
import { createOrder } from './../../../../../../../actions/firebase/orders';

const SetCardSendOrder = props => {
  const {
    dispatch,
    orderMode,
    toggleOrderMode,
    set,
  } = props;

  const prepareStyle = () => {
    const style = {
      marginLeft: '5px', display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }
    orderMode && (style.border = '1px solid #ddd');
    return style;
  }
  return (
    <div style={prepareStyle()}>
      {!orderMode &&
        <RaisedButton
          label='Заказать'
          onClick={
            () => {
              dispatch({ type: 'RESET_ORDER_CONDITIONS' });
              dispatch({ type: 'SET_ORDER_SET_ID', p: set.id });
              toggleOrderMode();
            }
          }
        >
        </RaisedButton>
      }
      {orderMode &&
        <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
          <PrepareOrder set={set} />
          <div>
            <RaisedButton
              label='Отправить заказ'
              onClick={
                () => {
                  dispatch(createOrder());
                  // dispatch({ type: 'SET_ORDER_SET_ID', p: '' });
                  // dispatch({ type: 'SET_SCREEN', name: 'setCard', val: false });
                  // dispatch({ type: 'SET_SCREEN', name: 'modelSets', val: false });
                  // dispatch({ type: 'SET_MAIN_SCREEN_PAGE', p: 'orders' });
                }
              }
            >
            </RaisedButton>
            <RaisedButton
              style={{marginLeft: '1px'}}
              label='Отмена'
              onClick={toggleOrderMode}
            >
            </RaisedButton>
          </div>
        </div>
      }
    </div>
  );
}

export default connect()(SetCardSendOrder);



// WEBPACK FOOTER //
// ./src/components/layout/content/catalog/set/card/card-zones/prepare-order-from-card.js